import { createApiSlice } from "@common";
import {
    MY_INFO_DOCUMENT_DETAILS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeInfoDocuments",
        method: "post",
        url: MY_INFO_DOCUMENT_DETAILS,
        stateKey: "message",
    },
    {
        name: "getEmployeeInfoDocuments",
        method: "get",
        url: MY_INFO_DOCUMENT_DETAILS,
        stateKey: "data",
    },
    {
        name: "updateEmployeeInfoDocuments",
        method: "put",
        url: MY_INFO_DOCUMENT_DETAILS,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeInfoDocuments",
        method: "delete",
        url: MY_INFO_DOCUMENT_DETAILS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeInfoDocuments",
    apiConfig,
    customReducers,
);
const EmployeeInfoDocumentsSlice = slice;
// Export the slice's reducer
export default EmployeeInfoDocumentsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeInfoDocuments,
    getEmployeeInfoDocuments,
    updateEmployeeInfoDocuments,
    deleteEmployeeInfoDocuments
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
